import PtIcon from '@patsnap-biz/icon';
import Tooltip from 'element-ui/lib/tooltip';
import { FIELD_TYPE } from '../../CustomFieldLabelController';
import DateRender from './render/DateRender.vue';
import LayerRender from './render/LayerRender.vue';
import NumRender from './render/NumRender.vue';
import OptionRender from './render/OptionRender.vue';
import StringRender from './render/StringRender.vue';
import UrlRender from './render/UrlRender.vue';
import DateEditor from './editor/DateEditor.vue';
import LayerEditor from './editor/LayerEditor.vue';
import NumEditor from './editor/NumEditor.vue';
import OptionEditor from './editor/OptionEditor.vue';
import StringEditor from './editor/StringEditor.vue';
import UrlEditor from './editor/UrlEditor.vue';
import '@patsnap-ui/icon/assets/solid/TextSurround.svg';
import '@patsnap-ui/icon/assets/solid/OneTwoThree.svg';
import '@patsnap-ui/icon/assets/solid/Calendar7.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOnOutline.svg';
import '@patsnap-ui/icon/assets/solid/Url.svg';
import '@patsnap-ui/icon/assets/solid/TreeHorizontal.svg';
import '@patsnap-ui/icon/assets/solid/PinFill.svg';
import '@patsnap-ui/icon/assets/solid/PinLine.svg';
import '@patsnap-ui/icon/assets/solid/AiTaggingStar.svg';
import '@patsnap-ui/icon/assets/solid/tick.svg';
export default {
    name: 'FieldContainer',
    components: {
        DateRender,
        LayerRender,
        NumRender,
        OptionRender,
        StringRender,
        UrlRender,
        DateEditor,
        LayerEditor,
        NumEditor,
        OptionEditor,
        StringEditor,
        UrlEditor,
        PtIcon,
        ElTooltip: Tooltip,
    },
    props: {
        fieldMainType: {
            type: String,
            required: true,
        },
        controller: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            renderMap: {
                [FIELD_TYPE.DATE]: DateRender,
                [FIELD_TYPE.LAYER]: LayerRender,
                [FIELD_TYPE.NUM]: NumRender,
                [FIELD_TYPE.OPTION]: OptionRender,
                [FIELD_TYPE.STRING]: StringRender,
                [FIELD_TYPE.URL]: UrlRender,
            },
            editorMap: {
                [FIELD_TYPE.DATE]: DateEditor,
                [FIELD_TYPE.LAYER]: LayerEditor,
                [FIELD_TYPE.NUM]: NumEditor,
                [FIELD_TYPE.OPTION]: OptionEditor,
                [FIELD_TYPE.STRING]: StringEditor,
                [FIELD_TYPE.URL]: UrlEditor,
            },
            fieldPtIconMappings: {
                [FIELD_TYPE.STRING]: 'SolidTextSurround',
                [FIELD_TYPE.NUM]: 'SolidOneTwoThree',
                [FIELD_TYPE.DATE]: 'SolidCalendar7',
                [FIELD_TYPE.OPTION]: 'SolidCheckboxOnOutline',
                [FIELD_TYPE.LAYER]: 'SolidTreeHorizontal',
                [FIELD_TYPE.URL]: 'SolidUrl',
            },
            fieldColorList: ['#f05c6c', '#9fbc34', '#85c9c1', '#f7d370', '#53c0fe', '#f9abbb', '#0d89d5', '#79aff3', '#9099cb', '#9cb3c3', '#ffa66a', '#00af86'],
        };
    },
    computed: {
        renderComponent() {
            return this.renderMap[this.field.field_type];
        },
        editorComponent() {
            return this.editorMap[this.field.field_type];
        },
    },
};
